import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';
import {
    Badge,
    Box,
    Card,
    Group,
    Stack,
    Text
} from '@mantine/core';
import {
    CancelButton,
    SubscribeNowButton
} from '../buttons';
import { useSubscribeToProduct } from '../hooks/useSubscribeToProduct';


const SubscribePageHeader = () => (
    <Box p="md">
        <Text size="xl" fw={700}>Subscribe to Product</Text>
        <Text size="sm" c="dimmed">Review and confirm your subscription</Text>
    </Box>
);

export const SubscribePage = () => {
    const {
        product,
        prices,
        loading,
        handleSubscribe,
        handleCancel
    } = useSubscribeToProduct();

    if (!product) {
        return <Text>Product not found</Text>;
    }

    return (
        <SimplePageLayout pageHeader={<SubscribePageHeader/>}>
            <SimplePageContentWrapper>
                <Stack gap="lg" maw={600} mx="auto">
                    <Card withBorder p="xl">
                        <Stack gap="md">
                            <Text size="xl" fw={600}>{product.name}</Text>
                            {product.shortDescription && (
                                <Text c="dimmed">{product.shortDescription}</Text>
                            )}

                            {prices.length > 0 && (
                                <Group gap="xs">
                                    <Text fw={500}>Price:</Text>
                                    <Badge size="lg" variant="light">
                                        ${(prices[0].amount / 100).toFixed(2)} / {prices[0].billingPeriod}
                                    </Badge>
                                </Group>
                            )}

                            {product.freeTrial && (
                                <Badge color="green" variant="light">Free Trial Available</Badge>
                            )}
                        </Stack>
                    </Card>

                    <Group justify="center" gap="md">
                        <CancelButton onClick={handleCancel}/>
                        <SubscribeNowButton
                            loading={loading}
                            onClick={handleSubscribe}
                        />
                    </Group>
                </Stack>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};


